export type PlayerVote = number | null | 'questionmark';

export function playerVoteToDisplayVote(vote: PlayerVote): string {
    if (vote === null) {
        return '';
    } else if (vote === 'questionmark') {
        return '?';
    } else {
        return vote.toString();
    }
}
